


























































































































import {Component, Provide, Vue} from 'vue-property-decorator';
import Paginition from '@/components/Paginition.vue';
import User from '@/models/user.ts';
import FilterMenu from '@/components/FilterMenu.vue';

import {API} from '@/services/api/api';
import {mapActions} from 'vuex';

import {Filter} from '@/utils/Filter';

import {Utils} from '@/utils/Utils';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  components: {
    Paginition,
    FilterMenu,
  },
})
export default class UserList extends Vue {
  //header filter(true false for showing filter menu)
  header = [
    {
      value: 'name',
      name: 'Name',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'email',
      name: 'Email',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
      bindClass: 'email-width',
    },
    {
      value: 'Role',
      name: 'Role',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'status',
      name: 'Status',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
    {
      value: 'created',
      name: 'Created',
      headerType: 'date',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'change-pass',
      name: 'Change Password',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
    {
      value: 'edit',
      name: 'Edit',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
    {
      value: 'delete',
      name: 'Delete',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
  ];
  userList: User[] = []; //api response
  filteredUserList: User[] = [];
  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point
  curentSort = ''; //current sort on which header
  numberOfRows = 5;

  //Store Variable
  showSuccessToast: any;
  showErrorToast: any;

  //Modal & Loader Variable
  isScreenLoading = false;
  modalVisible = false;
  loadingBtnStatus = false;
  modalConfimationMsg: any = null;
  modalTitle: any = null;

  userId: any = null;
  deleteStatus: any = null;
  asdcOrder = true;

  get isShipMode() {
    return process.env?.VUE_APP_MODE == 'Ship' ? true : false;
  }

  //sorting list
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredUserList);
    this.asdcOrder = sorted;
  }

  mounted() {
    this.getUserList();
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number, records: number) {
    this.numberOfRows = records;
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }
  // format date to human readable string
  formatDate(originalDate: string) {
    let formattedDate = Utils.formatDate(originalDate);
    return formattedDate;
  }

  //load list from api
  async getUserList() {
    this.isScreenLoading = true;
    try {
      let response = await API.getUserList();
      this.isScreenLoading = false;

      if (response.data) {
        let users: User[] = response.data;
        this.userList = users;
        this.filteredUserList = users;
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (e) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //filter data based upon string parameters
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.userList);

    this.filteredUserList = filteredData;
    this.resetPagination();
  }

  //filter data based upon date parameters
  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.userList);
    this.filteredUserList = filteredData;
    this.resetPagination();
  }

  //reset all filters and show current list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredUserList = this.userList;
      this.resetPagination();
    }
  }

  //show delete confirmation  modal
  displayDeleteModal(recordId: number) {
    this.userId = recordId;
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure want to delete ?';
    this.deleteStatus = true;
  }

  //show activate/deactivate  confirmation  modal
  displayStatusModal(recordId: number, recordEnableStatus: boolean) {
    this.userId = recordId;
    let msg;
    if (recordEnableStatus) {
      msg = 'Deactivate';
    } else {
      msg = 'Activate';
    }
    this.modalVisible = true;
    this.modalTitle = `${msg} Confirmation`;
    msg = msg.toLowerCase();
    this.modalConfimationMsg = `Are you sure want to ${msg} ?`;
    this.deleteStatus = false;
  }

  //call delete or activate/deactivate method based upon confirmation
  async deleteOrChangeStatus() {
    try {
      const response = this.deleteStatus ? await this.deleteUser(this.userId) : await this.changeStatus(this.userId);

      const message = this.deleteStatus ? 'Record deleted successfully' : 'Record updated successfully';

      if (response.data) {
        this.showSuccessToast({msg: message});
        this.getUserList();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //delete record
  async deleteUser(userId) {
    return await API.deleteUserById(this.userId);
  }
  //change status of user
  async changeStatus(userId) {
    const user = this.userList.find((u) => u.id === userId);
    const status = !user.enabled;
    const loginStatus = status ? user.isLoginEnabled : false;
    return await API.activateOrDeactivateUser(user.id, status, loginStatus);
  }

  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  // navigate to change-password screen
  changePassword(userId: number) {
    this.$router.push('/change-password/' + userId);
  }

  // navigate to create-user screen
  goToCreateUser() {
    this.$router.push('/create-user');
  }

  // navigate to edit-user screen
  public editUser(userId: number) {
    this.$router.push({path: '/edit-user/' + userId});
  }
}
